import { darkTheme } from "@yleisradio/yds-core";
import styled, { css, keyframes, RuleSet } from "styled-components";

import { focusColor } from "./variables";

export const ControlBarButton = styled.button`
  align-items: center;
  border: none;
  color: ${darkTheme.ACTION_PRIMARY};
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  padding: 0;
  pointer-events: auto;
  width: 32px;
  &:focus-visible {
    outline: 1px solid ${focusColor} !important;
  }
`;

const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;
const fadeOut = keyframes`
  0% { opacity: 1; }
  100% { opacity: 0; }
`;

export const visibilityTransition = (visible: boolean): RuleSet => css`
  opacity: ${visible ? 1 : 0};
  animation-name: ${visible ? fadeIn : fadeOut};
  animation-duration: 0.2s;
`;
